import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { InformacionConvenios } from "./TypesConvenios";
//URL
import configData from "config.json"
import { alertService } from "components/Varios/alert_service";


const URL_GET_CONVENIOS = "DatosConvenios/"
const URL_DOWNLOAD_CONVENIO = URL_GET_CONVENIOS + "FileConvenios/"

export function handleHeader(token: string) {
    return {
        'Content-Type': 'application/json',
        Authorization: `KEYESPOL ${token}`,

    }
}


export async function ObtenerConveniosUsuario(datosPersona: UserData) {
    var convenios: Array<InformacionConvenios> = []
    try {
        const respuesta = await axios.get(configData.SERVER_URL + URL_GET_CONVENIOS, {
            headers: handleHeader(datosPersona.token)
        })
        convenios = respuesta.data;
    } catch (error) {
        alertService.error("Ha ocurrido un inconveniente al tratar de obtener los Convenios");
    }
    return convenios;
}

export async function DescargarConvenio(idArchivo: string) {
    const respuesta = await fetch( configData.SERVER_URL + URL_DOWNLOAD_CONVENIO + idArchivo)
        .then(response => {
            if(response.ok) {
                response.blob().then(blob => {
                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = "Convenio";
                    a.click();
                });
            }
            else {
                alertService.error("Ha ocurrido un inconveniente al intentar descargar el Archivo")
            }
            
        })
        .catch(error => {
        });
}